// Module
var code = `<template>
  <require from="./edit-instrument-dialog.scss"></require>

  <mdc-dialog view-model.ref="dialog" class="edit-instrument-dialog" draggable-dialog>
    <mdc-dialog-title>\${isNew ? 'Create un-noted' : 'Edit'} instrument</mdc-dialog-title>
    <mdc-dialog-content>
      <mdc-layout-grid no-padding>
        <div class="mdc-layout-grid__inner">

          <mdc-layout-grid-cell spans="2 4 12" new-row>
            <mdc-select label="Instrument type" value.bind="instrument.instrumentTypeId & validate" hoist-to-body change.delegate="instrumentTypeChanged()">
              <mdc-list>
                <mdc-list-item repeat.for="it of instrumentTypes" value.bind="it.id">\${it.name}</mdc-list-item>
              </mdc-list>
            </mdc-select>
            <mdc-select-helper-text validation></mdc-select-helper-text>
          </mdc-layout-grid-cell>

          <mdc-layout-grid-cell spans="2 4 12" new-row>
            <mdc-text-field label="Name" value.bind="instrument.name & validate" disabled.bind="isNoted"></mdc-text-field>
            <mdc-text-field-helper-line></mdc-text-field-helper-line>
          </mdc-layout-grid-cell>

          <mdc-layout-grid-cell spans="2 4 12" new-row if.bind="!isNew">
            <mdc-text-field label="Report name" value.bind="instrument.reportName & validate"></mdc-text-field>
            <mdc-text-field-helper-line></mdc-text-field-helper-line>
          </mdc-layout-grid-cell>

          <mdc-layout-grid-cell>
            <mdc-text-field label="ISIN" value.bind="instrument.isin & validate" disabled.bind="isNoted" change.delegate="isinChanged()"></mdc-text-field>
            <mdc-text-field-helper-line></mdc-text-field-helper-line>
          </mdc-layout-grid-cell>

          <mdc-layout-grid-cell>
            <mdc-text-field label="OrgNr" value.bind="instrument.orgNr & validate" disabled.bind="isNoted"></mdc-text-field>
            <mdc-text-field-helper-line></mdc-text-field-helper-line>
          </mdc-layout-grid-cell>

          <mdc-layout-grid-cell>
            <currency-lookup label="Currency Code" disabled.bind="isNoted" value.bind="instrument.currencyCode & validate"></currency-lookup>
          </mdc-layout-grid-cell>

           <mdc-layout-grid-cell>
             <mdc-text-field ref="countryInput" label="Country"></mdc-text-field>
             <mdc-lookup options.bind="countries" display-field="name" value-field="code" debounce="0" value.bind="instrument.countryCode" input.bind="countryInput" preload-options natural-width hoist-to-body perfect-scrollbar>
               <template replace-part="option">\${option.name}</template>
             </mdc-lookup>
           </mdc-layout-grid-cell>

          <mdc-layout-grid-cell spans="4 4 3" new-row>
            <mdc-form-field>
              <mdc-checkbox checked.bind="instrument.instrumentLongTerm" change.trigger="longTermChanged()"></mdc-checkbox>
              <label>Long term</label>
            </mdc-form-field>
          </mdc-layout-grid-cell>

          <mdc-layout-grid-cell spans="4 4 3">
            <mdc-form-field>
              <mdc-checkbox checked.bind="instrument.instrumentTaxable"></mdc-checkbox>
              <label>Taxable</label>
            </mdc-form-field>
          </mdc-layout-grid-cell>

          <mdc-layout-grid-cell spans="4 4 3">
            <mdc-form-field>
              <mdc-checkbox checked.bind="instrument.instrumentLowerOfCostOrMarket"></mdc-checkbox>
              <label>Lower of cost or market</label>
            </mdc-form-field>
          </mdc-layout-grid-cell>

        </div>
      </mdc-layout-grid>
    </mdc-dialog-content>
    <mdc-dialog-actions>
      <button mdc-button outlined data-mdc-dialog-action="cancel">Cancel</button>
      <button mdc-button raised click.delegate="save()">Save</button>
    </mdc-dialog-actions>
  </mdc-dialog>
</template>
`;
// Exports
export default code;